import { Translation } from '../contract/translation.contract';
import { translatedPropertyService } from '../shared/i18n/translated-property.service';

export const translatedProperty = (property: Translation): string => {
  return (property && translatedPropertyService.translateProperty(property)) || '';
};
